import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { TaskValidation } from 'uplisting-frontend/validations';

export default class TaskRepositoryService extends BaseRepositoryService<
  ModelRegistry['task']
> {
  recordName = 'task';
  implementMethods = [
    'query',
    'findRecord',
    'createRecord',
    'buildChangeset',
    'save',
  ];

  validation = TaskValidation;

  async forDates(from: string, to: string) {
    return this.query({ from, to });
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/task': TaskRepositoryService;
  }
}
